import '../../../../vendor/angular-ui-router/release/angular-ui-router';

export const uiRouterModule = 'ui.router';
export const uiRouterStateModule = 'ui.router.state';
